console.log('Product notification script loaded');

function initProductNotification() {
  console.log('Initializing product notification');
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  const notifyButton = document.querySelector('[data-action="notify-me"]');
  const emailInput = document.querySelector('input[name="contact[email]"]');
  const notificationContainer = document.querySelector('.product-form__notification');

  console.log('Form:', form);
  console.log('Notify button:', notifyButton);
  console.log('Email input:', emailInput);

  if (notifyButton) {
    notifyButton.addEventListener('click', handleNotifyMe);
  }

  function handleNotifyMe(event) {
    console.log('handleNotifyMe called');
    event.preventDefault();
    const email = emailInput.value;
    const variantId = form.querySelector('[name="id"]').value;

    if (email && variantId) {
      notifyButton.classList.add('loading');
      notifyButton.disabled = true;

      // Here, you would typically send this data to your server or a third-party service
      // For this example, we'll use a setTimeout to simulate an API call
      setTimeout(() => {
        console.log(`Notification requested for variant ${variantId} to email ${email}`);
        showMessage('Thank you! We will notify you when this product is back in stock.', 'success');
        emailInput.value = '';
        notifyButton.classList.remove('loading');
        notifyButton.disabled = false;
      }, 1000);
    } else {
      showMessage('Please enter a valid email address.', 'error');
    }
  }

  function showMessage(message, type) {
    const messageElement = document.createElement('div');
    messageElement.textContent = message;
    messageElement.classList.add('notification-message', `notification-message--${type}`);
    notificationContainer.appendChild(messageElement);

    setTimeout(() => {
      messageElement.remove();
    }, 5000);
  }
}

// Initialize the script when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductNotification);
} else {
  initProductNotification();
}